// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"145":"e38c32db","276":"545ba2a1","321":"9f255171","759":"4690640f"}[chunkId] + ".js";
};